const Num50_500 = [
  { id: "10", value: "10" },
  { id: "20", value: "20" },
  { id: "50", value: "50" },
  { id: "100", value: "100" },
  { id: "150", value: "150" },
];

export default Num50_500  